import { Flex } from 'ui/Layout';

import { ReadOnlySankeyChart } from '../../components/SankeyChart';
import { useCanvasColumnProps } from './utils';

const ReadOnlyLayout: React.FC = () => {
  const canvasColumnProps = useCanvasColumnProps();

  return (
    <Flex mx="auto" {...canvasColumnProps}>
      <ReadOnlySankeyChart />
    </Flex>
  );
};

export default ReadOnlyLayout;
